import React from "react"

export default () => {
  return (
    <footer className="px-3 py-5 w-full bg-gray-800 text-white">
      © {new Date().getFullYear()} Exindeco
      <span className="float-right">
        <a
          href="https://www.facebook.com/Exindeco-286142165353920/"
          target="_blank"
          className="mr-2"
        >
          <i className="fa fa-fw fa-inverse fa-facebook" />
        </a>
        <a
          href="https://www.instagram.com/exin.deco/"
          target="_blank"
          className="mr-2"
        >
          <i className="fa fa-fw fa-inverse fa-instagram" />
        </a>
      </span>
    </footer>
  )
}
